import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { LibModule } from '@ui-components/lib.module';

import { ChatBoxComponent } from './chat-box/chat-box.component';
import { MessageContentComponent } from './chat-box/message-content/message-content.component';
import { ChatComponent } from './chat.component';
import { SidenavComponent } from './sidenav/sidenav.component';
import { WelcomeBoxComponent } from './welcome-box/welcome-box.component';

@NgModule({
  declarations: [
    ChatComponent,
    ChatBoxComponent,
    MessageContentComponent,
    SidenavComponent,
    WelcomeBoxComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    LibModule
  ],
  exports: [
    ChatComponent
  ]
})
export class ChatModule { }
